import * as React from "react"
import {connect} from "react-redux"
import {isNull as _isNull} from "lodash"
import {IAppointmentScheduleResponse} from "@curefit/care-common";
import {AppointmentsActions} from "../actions/AppointmentsActions";
import {IConsultationUpdateParams} from "../models/appointment/IConsultationUpdateParams";
import {IAppState} from "../models/IAppState";

/**
 * Created by aditya on 06/02/18.
 */

export interface ConsultationDelayProps {
    consultation: IAppointmentScheduleResponse;
    triggeredIn: number;
    hideContainer: () => void;
}

export interface ConsultationDelayState {
    delay: number;
    showLabel: boolean;
    delaySlotsVisibile: boolean;
}

class ConsultationDelay extends React.Component<ConsultationDelayProps & IDispatchProps, ConsultationDelayState> {
    constructor(props: ConsultationDelayProps & IDispatchProps) {
        super(props);
        this.state = {
            delay: null,
            showLabel: true,
            delaySlotsVisibile: false
        }
    }
    componentDidMount() {
        let myInstance = this;
        setTimeout(() => {
            if (myInstance.state.delaySlotsVisibile === false) myInstance.setState({showLabel: false});
        }, 10000)
    }
    componentWillReceiveProps(nextProps: ConsultationDelayProps) {
        let myInstance = this;
        if (nextProps.triggeredIn !== this.props.triggeredIn)
        this.setState({
            showLabel: true
        }, () => {
            setTimeout(() => {
                if (myInstance.state.delaySlotsVisibile === false) myInstance.setState({showLabel: false});
            }, 10000)
        })
    }
    toggleDelaySlots = (flag: boolean) => {
        this.setState({
            showLabel: false,
            delaySlotsVisibile: flag
        })
    }
    updateAppointment = (minutes: number) => {
        let myInstance = this;
        let bookingId = this.props.consultation.bookingId;
        let appointmentId = this.props.consultation.id;
        let params: IConsultationUpdateParams = {
            delayedInMinutes: minutes
        }
        this.props.updateAppointment(bookingId, appointmentId, params).then((data) => {
            myInstance.setState({showLabel: false, delay: minutes, delaySlotsVisibile: false})
        });
    }
    render() {
        return (
            <div className={"consultation-delay-container animated fadeInLeft"}>
                {
                    this.state.delaySlotsVisibile &&
                    <div className={"delay-slots animated fadeInLeft"}>
                        {
                            !_isNull(this.state.delay) &&
                            <a onClick={() => this.updateAppointment(0)}>0 minutes</a>
                        }
                        <a onClick={() => this.updateAppointment(5)}>5 minutes</a>
                        <a onClick={() => this.updateAppointment(10)}>10 minutes</a>
                        <a onClick={() => this.updateAppointment(15)}>15 minutes</a>
                        <a className={"cancel"} onClick={() => this.toggleDelaySlots(false)}>Cancel</a>
                    </div>
                }
                {
                    !this.state.delaySlotsVisibile &&
                    <div className={"button-container animated fadeInLeft"}>
                        <a onClick={() => this.toggleDelaySlots(true)}>
                            {
                                !_isNull(this.state.delay) &&
                                <span>Delay: {!_isNull(this.state.delay) ? `${this.state.delay} minutes` : ""}</span>
                            }
                            {
                                _isNull(this.state.delay) &&
                                <span>Delayed?</span>
                            }
                        </a>
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state: IAppState) => {
    return {
    }
}

interface IDispatchProps {
    updateAppointment(bookingId: number, appointmentId: number, consultationUpdateParams: IConsultationUpdateParams): Promise<any>
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        updateAppointment: (bookingId: number, appointmentId: number, consultationUpdateParams: IConsultationUpdateParams) => {
            return AppointmentsActions.updateAppointment(dispatch, bookingId, appointmentId, consultationUpdateParams);
        }
    }
}

export default connect<any, IDispatchProps, ConsultationDelayProps>(mapStateToProps, mapDispatchToProps)(ConsultationDelay);